const TAG_LIST_GET = 'TAG_LIST_GET'
const TAG_LIST_GET_SUCCESS = 'TAG_LIST_GET_SUCCESS'
const TAG_LIST_GET_ERROR = 'TAG_LIST_GET_ERROR'

const TAG_CREATE = 'TAG_CREATE'
const TAG_CREATE_SUCCESS = 'TAG_CREATE_SUCCESS'
const TAG_CREATE_ERROR = 'TAG_CREATE_ERROR'

const TAG_UPDATE = 'TAG_UPDATE'
const TAG_UPDATE_SUCCESS = 'TAG_UPDATE_SUCCESS'
const TAG_UPDATE_ERROR = 'TAG_UPDATE_ERROR'

const TAG_DELETE = 'TAG_DELETE'
const TAG_DELETE_SUCCESS = 'TAG_DELETE_SUCCESS'
const TAG_DELETE_ERROR = 'TAG_DELETE_ERROR'

export {
  TAG_LIST_GET,
  TAG_LIST_GET_SUCCESS,
  TAG_LIST_GET_ERROR,
  TAG_CREATE,
  TAG_CREATE_SUCCESS,
  TAG_CREATE_ERROR,
  TAG_UPDATE,
  TAG_UPDATE_SUCCESS,
  TAG_UPDATE_ERROR,
  TAG_DELETE,
  TAG_DELETE_SUCCESS,
  TAG_DELETE_ERROR,
}
